import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild
} from "@angular/core";
import {AbstractListView} from "../../../core/visbos-core/ui/components/abstract-list-view";
import {DatatableComponent} from "../../../core/visbos-core/ui/components/datatable/datatable.component";
import {FormArray, FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {SessionActions} from "../../../shared/actions/session.actions";
import {Order} from "../../../shared/view-model/store-management/order.type";
import {OrderItem} from "../../../shared/view-model/store-management/order-item.type";
import {debounceTime, distinctUntilChanged} from "rxjs/operators";
import {AbstractVisbosComponent} from "../../../core/visbos-core/components/abstract-visbos.component";
import {StockItemService} from "../../services/stock-item-service/stock-item.service";
import {Packing} from "../../../shared/view-model/store-management/packing.type";
import {GenericModalComponent} from "../../../core/visbos-core/ui/forms/generic-modal/generic-modal.component";
import {ProductBatchFormComponent} from "../../product/product-batch-form/product-batch-form.component";
import {ProductBatch} from "../../model/product-batch.type";
import {AbstractVisbosControl} from "../../../core/visbos-core/ui/forms/abstract-visbos-control";

@Component({
  selector: 'vb-delivery-items-list',
  templateUrl: './delivery-items-list.component.html',
  styleUrls: ['./delivery-items-list.component.css']
})
export class DeliveryItemsListComponent extends AbstractListView implements OnInit, AfterViewInit {

  that;

  @Input()
  control: FormArray;

  @Input()
  order: Order;

  @ViewChild('stockDetails')
  orderItemDetails: TemplateRef<any>;

  @ViewChild('editAmountTmpl')
  editAmountTmpl: TemplateRef<any>;

  @ViewChild('orderAmountTmpl')
  orderAmountTmpl: TemplateRef<any>;

  @ViewChild('orderPackingTmpl')
  orderPackingTmpl: TemplateRef<any>;

  @ViewChild('targetStockTmpl')
  targetStockTmpl: TemplateRef<any>;

  @ViewChild('packingUnitTmpl')
  packingUnitTmpl: TemplateRef<any>;

  @ViewChild('productBatchesTmpl')
  productBatchesTmpl: TemplateRef<any>;

  @ViewChild('deliveryItemsTable')
  table: DatatableComponent;

  showDeliveredItems: boolean = false;

  editable: { [cuid: string]: boolean };

  messages = {
    emptyMessage: 'Keine Artikel im Wareneingang vorhanden',
    totalMessage: 'Artikel im Wareneingang insgesamt'
  };

  @ViewChild('packingModal')
  packingModal: GenericModalComponent;

  packings: Packing[] = [];
  packingForm: FormControl;
  editedItemCuid: string;

  @ViewChild('pbModal')
  pbModal: GenericModalComponent;
  pbForm: FormGroup;


  get deliveryItems(): any[] {
    return this.control ? this.control.value : [];
  }

  selectedItems = [];

  @Output()
  selectedChange: EventEmitter<any[]> = new EventEmitter();


  constructor(private fb: FormBuilder, sessionActions: SessionActions, cd: ChangeDetectorRef,
              private stockItemService: StockItemService) {

    super(sessionActions, cd);

    this.that = this;

    this.control = this.fb.array([]);

  }

  ngOnInit() {

    super.ngOnInit();

    this.addSubscription(this.control.valueChanges.subscribe(
      val => {
        this.rows = val;
        this.filterItems();
      }));

    this.dataSubscriptions.push(
      this.searchTerm.valueChanges.pipe(
        distinctUntilChanged(),
        debounceTime(500)
      ).subscribe((term: any) => {
        this.currentSearchTermValue.next(term);
        this.filterItems(term);
      })
    );

    this.columns = [
      {prop: 'article_number', name: 'Art.-Nr.', minWidth: 50, maxWidth: 100, flexGrow: 2},
      {prop: 'article_label', name: 'Bezeichner', minWidth: 250, flexGrow: 4},
      {
        name: 'Bestellmenge',
        cellTemplate: this.orderAmountTmpl,
        minWidth: 50,
        maxWidth: 100,
        flexGrow: 1,
        sortable: false
      },
      {
        name: 'Bestelleinheit',
        cellTemplate: this.orderPackingTmpl,
        minWidth: 50,
        maxWidth: 100,
        flexGrow: 1,
        sortable: false
      },
      {
        name: 'Geliefert?',
        minWidth: 50,
        maxWidth: 100,
        flexGrow: 1,
        sortable: false,
        draggable: false,
        headerCheckboxable: true,
        checkboxable: true
      },
      {
        name: 'Liefermenge',
        cellTemplate: this.editAmountTmpl,
        minWidth: 50,
        maxWidth: 100,
        flexGrow: 1,
        sortable: false
      },
      {
        name: 'Liefereinheit',
        cellTemplate: this.packingUnitTmpl,
        minWidth: 100,
        maxWidth: 150,
        flexGrow: 2,
        sortable: false
      },
      {name: 'Einlagern', cellTemplate: this.targetStockTmpl, minWidth: 150, flexGrow: 3, sortable: false},
      {name: 'Chargen', cellTemplate: this.productBatchesTmpl, minWidth: 100, flexGrow: 2, sortable: false}
    ];

  }

  ngAfterViewInit(): void {
    super.ngAfterViewInit();
    this.cd.detectChanges();
  }

  getOrderItem(deliveryItem): OrderItem {
    return this.order.order_items.find(item => item.cuid === deliveryItem.referenced_order_item_id);
  }

  getFormGroupByCuid(cuid: string): FormGroup {
    return AbstractVisbosComponent.getFormGroupById(this.control, cuid, 'cuid');
  }

  filterItems(searchTerm?) {

    if (!searchTerm) {
      searchTerm = this.currentSearchTermValue.value;
    }

    if (!searchTerm || searchTerm == "") {
      this.rows = this.deliveryItems;
    } else {
      if (this.deliveryItems) {
        this.rows = this.deliveryItems.filter((si: any) => this.findStringInTable(si, this.columns, searchTerm));
      }
    }

  }

  editProductPacking(deliverItem) {

    const stockItem = this.getOrderItem(deliverItem).stock_item;

    this.packingForm = this.fb.control(deliverItem.product_packing_id);
    this.editedItemCuid = deliverItem.cuid;

    this.addSubscription(this.stockItemService.getProductPackingsForStockItem(stockItem.cuid).subscribe(res => {
      this.packings = res.data.productPackings;
    }));

    this.packingModal.show();

  }

  saveProductPacking() {

    const packing: Packing = this.packingForm.value ? this.packings.find(p => p.cuid == this.packingForm.value) : null;

    const data = {
      product_packing_id: packing ? packing.cuid : null,
      packing_unit: packing ? packing.packing_unit.packing_unit_name : null,
      packing_content: packing ? packing.packing_amount : null,
      price: packing ? packing.packing_price : null
    };

    this.getFormGroupByCuid(this.editedItemCuid).patchValue(data);
    this.cd.detectChanges();

    this.editedItemCuid = null;
    this.packingForm = null;
    this.packings = [];

  }

  addProductPackingClicked(deliveryItem) {

  }

  addProductPacking() {

  }

  addProductBatchClicked(deliveryItem) {
    this.pbModal.state = {deliveryItemCuid: deliveryItem.cuid};
    this.pbForm = ProductBatchFormComponent.initControl(this.fb);
    this.pbModal.show();
  }

  addProductBatch() {
    let productBatch = this.pbForm.value;
    this.pbForm = null;
    let deliveryItemCuid = this.pbModal.state.deliveryItemCuid;
    let pb = this.initProductBatchFormGroup(productBatch);
    let pbArray = this.getFormGroupByCuid(deliveryItemCuid).get('product_batches') as FormArray;
    pbArray.push(pb);
  }

  removeProductBatch(deliveryItemCuid: string, productBatchCuid: string) {
    let st = this.getFormGroupByCuid(deliveryItemCuid).get('product_batches') as FormArray;
    let index = st.controls.findIndex(i => i.get('cuid').value == productBatchCuid);
    if (index > -1) {
      st.removeAt(index);
    }
  }

  initProductBatchFormGroup(productBatch?: ProductBatch): FormGroup {
    let f = this.fb.group({
      cuid: [AbstractVisbosControl.cuid(), Validators.required],
      batch_number: [null],
      use_before_date: [null]
    });

    if (productBatch) {
      f.patchValue(productBatch);
    }

    return f;
  }

  onSelectedChanged(selected: any[]) {
    this.selectedItems = selected;
    this.selectedChange.emit(this.selectedItems);
  }

  rowIsSelected(row): boolean {
    return this.selectedItems.findIndex(cuid => cuid == row.cuid) > -1;
  }

}



// WEBPACK FOOTER //
// ./src/app/store-management/procurement/delivery-items-list/delivery-items-list.component.ts